


















































































































































































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { contactsCollection, Timestamp } from "../../db";



@Component({})
export default class Contacts extends Vue {
  @Getter contacts;

  private search = "";
  private dialog = false;
  private formEditMode = false;
  private form = {
    id: undefined,
    company: "",
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    address: "",
    notes: "",
  };

  private headers = [
    { text: "Edit", value: "edit", sortable: false },
    { text: "Company", value: "company" },
    { text: "Name", value: "name" },
    { text: "Contact Info", value: "info" },
    { text: "Address", value: "address" },
    { text: "Created", value: "created" },
    { text: "Delete", value: "delete" },
  ];

  async add() {
    delete this.form.id;
    await contactsCollection.add({
      created: Timestamp.now(),
      ...this.form,
    });
    this.dialog = false;
    this.formEditMode = false;
    this.clearForm();
  }

  edit(item) {
    this.form = {
      id: item.id,
      ...item,
    };
    this.formEditMode = true;
    this.dialog = true;
  }

  async save() {
    const id = this.form.id;
    delete this.form.id;
    await contactsCollection.doc(`${id}`).update({
      ...this.form,
    });
    this.dialog = false;
    this.formEditMode = false;
    this.clearForm();
  }

  async remove(item) {
    await contactsCollection.doc(`${item.id}`).delete();
  }

  close() {
    this.dialog = false;
    this.clearForm();
  }

  clearForm() {
    this.form = {
      id: undefined,
      company: "",
      firstName: "",
      lastName: "",
      phone: "",
      email: "",
      address: "",
      notes: "",
    };
  }

  formatCreated(item) {
    if (item.created) {
      const date = item.created.toDate();
      if (date.getFullYear() != 1969) {
        return date.toLocaleDateString();
      }
    }
    return "N/A";
  }
}
